export const getEffectiveMonthlyPayment = ({ term, payment, dueAtSigning }) => payment + dueAtSigning / term;
